import { Divider, Typography, Stack, tokens } from '@cast/design-system';

import { useClmCompatibleFamiliesPicker } from './ClmCompatibleFamiliesPickerProvider';
import { InstanceChip } from './InstanceChip';

export const SelectionSummary = () => {
  const { selectedInstances, baseInstance } = useClmCompatibleFamiliesPicker();

  if (!baseInstance) {
    return null;
  }

  return (
    <Stack gap={4} data-testid="summary-section">
      <Typography variant="A1" color={tokens.theme.fg.structural.primary}>
        Selection summary:
      </Typography>
      <Stack
        border={tokens.theme.border.structural.neutralSubtle}
        bgcolor={tokens.theme.bg.structural.surfaceSubtle}
        p={12}
        direction="row"
        gap={8}
      >
        <Stack pr={15} gap={8}>
          <Typography
            variant="L10M"
            color={tokens.theme.fg.structural.secondary}
          >
            Base:
          </Typography>
          <InstanceChip
            instance={baseInstance}
            checked
            testId="base-instance"
          />
        </Stack>
        <Divider
          color={tokens.theme.border.structural.neutralSubtle}
          orientation="vertical"
          flexItem
        />
        <Stack minWidth={40} gap={8}>
          <Typography
            variant="L10M"
            color={tokens.theme.fg.structural.secondary}
          >
            compatible:
          </Typography>
          <Stack direction="row" gap={8} flexWrap="wrap">
            {selectedInstances.map((instance) => (
              <InstanceChip key={instance} instance={instance} checked />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
